import { FC } from 'react';
import cn from 'clsx';
import Link, { LinkProps } from '@v2/shared/components/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';

type Props = LinkProps & {
  icon: IconLookup;
};

/**
 * A social icon, sized as a target rather than as a glyph.
 *
 * No longer built on FooterLink: that one is a 44px-tall *row* in a column of links and
 * a square icon wants a 44px *box*, so the two disagree about `display` — and since `cn`
 * is clsx, composing them would leave both classes on the element and let the stylesheet
 * pick. The 44px floor holds at every width here rather than being dropped above lg: a
 * 32px glyph is an awkward target with a mouse too, and there are only three of them, so
 * nothing else in the column moves to make room.
 */
const FooterIconLink: FC<Props> = ({ icon, className, ...props }) => {
  return (
    <Link
      className={cn(
        'inline-flex min-h-[44px] min-w-[44px] items-center justify-center text-slate-400 hover:text-slate-300',
        className
      )}
      {...props}
    >
      <FontAwesomeIcon icon={icon} size="2x" />
    </Link>
  );
};

export default FooterIconLink;
